import axios from "src/service/axios_c";
import Admin from "@system/config/admin";
import Helper from "src/support/Helper";
import Base from "../Base";

class AdminCommonAPICall extends Base {

    getRoleList = async (params = {}) => {
        let res = [];

        await this.axiosCall(Admin.GET_ROLE_LIST, params, 'GET').then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
        return res;
    };
    getOrgList = async (params = {}) => {
        let res = {};
        await this.axiosCall(Admin.GET_ORG_LIST, params, 'GET', true).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
        return res;
    };

    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false) => {
        data = await this.mergeDataWithBase(data);
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        if (isBlob) {
            config.responseType = 'blob';
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        return {
            ...data
        };
    };
}

export default AdminCommonAPICall;